/* eslint-disable no-unused-vars */
export enum AndromedaButtonTypes {
  Basic = 'basic',
  Raised = 'raised',
  Strocked = 'stroked',
  Flat = 'flat',
  Icon = 'icon',
}
